export const CardErrorType = {
  TransactionFailed: "TRANSACTION_FAILED",
} as const;
export type TCardErrorType = (typeof CardErrorType)[keyof typeof CardErrorType];
